import React, { memo } from 'react';
import { Panel, PanelHeader, PanelBody } from '../../../components/panel/panel.jsx';
import FormMessageBlast from './components/FormMessageBlast.js';

const MessageBlastCreate = (props) => {
  return (
    <div>
      <h1 className="page-header">Message Blast Create</h1>
      <div className="row">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Information</PanelHeader>
            <PanelBody>
              <FormMessageBlast action="create" />
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default memo(MessageBlastCreate);
